module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iNjAwIiB2aWV3Qm94PSIwIDAgOSA2Ij48cGF0aCBmaWxsPSIjMjE0NjhCIiBkPSJNMCAwaDl2NkgweiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0wIDBoOXY0SDB6Ii8+PHBhdGggZmlsbD0iI0FFMUMyOCIgZD0iTTAgMGg5djJIMHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/bes.svg
// module id = IJvQ
// module chunks = 0